const initialState = {
    items: [],
    select: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'GET_GLOBALS':
            const select = [];

            action.payload.fieldDefinitions.forEach((fieldDefinition) => {
                select.push({
                    id: fieldDefinition.id,
                    title: fieldDefinition.key
                });
            });

            return {
                ...state,
                items: action.payload.fieldDefinitions,
                select: select
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/store/reducers/fielddefinition.js